import { Popover } from "@mui/material";
import React from "react";
import BoxComponent from "../../../Box/BoxComponent";
import TypographyComponent from "../../../Typography/ThypographyComponent";
import ButtonComponent from "../../../Button/ButtonComponent";
import SvgComponent from "../../../Image/SvgComponent";
import { ReactComponent as EditIcon } from "../../../../assets/icons/dashboard/lapis.svg";
import { ReactComponent as ChaveIcon } from "../../../../assets/icons/dashboard/chave.svg";
import { ReactComponent as Logouticon } from "../../../../assets/icons/dashboard/sair.svg";

interface PopopverHeaderProps {
    open: boolean,
    anchorEl: HTMLElement | null;
    nome?: string,
    telefone?: string,
    cargo?: string,
    onClosePopover: () => void,
    onClickLogout: () => void
}

const PopoverHeaderComponent = (props: PopopverHeaderProps) => {
    const buttonsStyle = {
        textTransform: 'uppercase',
        fontFamily: '"Inter", sans-serif',
        fontWeight: 200,
        fontSize: '14px',
        lineHeight: '24.5px',
        letterSpacing: '0%',
        textAlign: 'left',

        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: "#4B5563",
        gap: 2
    };

    const svgStyle = {
        display: "flex",
        alignpropss: "center",
        justifyContent: "center",
        width: 20,
        height: 20,
        "& svg, & svg *": {
            fill: "#4B5563",
            //stroke: "#6A7282",
        },
    };

    return <Popover
        open={props.open}
        anchorEl={props.anchorEl}
        onClose={props.onClosePopover}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
        }}
        transformOrigin={{
            vertical: "top",
            horizontal: "right",
        }}
        slotProps={{
            paper: {
                sx: {
                    width: 285,
                    minWidth: 285,
                    p: 2,
                }
            }
        }}
        sx={{
            display: 'flex',
            flexDirection: 'column',
            opacity: 1,
            boxSizing: 'border-box',
        }}
    >
        <BoxComponent component="div"
            sx={{
                //width: 300,
                display: "flex",
                flexDirection: "column",
                gap: 2,
                p: 1
            }}
        >
            <TypographyComponent variant="h5"
                sx={{
                    fontFamily: '"Inter", sans-serif',
                    fontWeight: 600,
                    fontSize: '18px',
                    lineHeight: '25.71px', // Convertido do token 25_71
                    letterSpacing: '0%',
                    display: 'inline-flex',
                    alignItems: 'center',
                    verticalAlign: 'middle',
                    color: "#4B5563"
                }}
            >
                Olá, {props.nome}!
            </TypographyComponent>

            <TypographyComponent
                variant="body2"
                sx={{
                    fontFamily: '"Inter", sans-serif',
                    fontWeight: 200,
                    fontSize: '16px',
                    lineHeight: '22.86px', // Convertido do token 22_86
                    letterSpacing: '0%',
                    color: '#6B7280',
                    display: 'inline-flex',
                    alignItems: 'center',
                    verticalAlign: 'middle'
                }}
            >
                {props.telefone}
            </TypographyComponent>

            <BoxComponent
                component="div"
                sx={{
                    width: "fit-content",
                    px: 2,
                    py: 1,
                    borderRadius: 2,
                    backgroundColor: "#FFE4D0",
                    fontFamily: '"Inter", sans-serif',
                    fontWeight: 700,
                    fontSize: '14px',
                    lineHeight: '20px',
                    letterSpacing: '0%',
                    color: '#FF8C42',
                    textAlign: 'center',
                    display: 'block', // 'block' ou 'flex' com justifyContent garante que a centralização funcione
                    alignItems: 'center',
                    justifyContent: 'center',
                    verticalAlign: 'middle',
                    textTransform: "uppercase"
                }}
            >
                {props.cargo}
            </BoxComponent>
        </BoxComponent>
        <BoxComponent component="div"
            sx={{
                //width: 300,
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 2,
                p: 1
            }}
        >
            <ButtonComponent id="botao-edicao-perfil" disabled sx={buttonsStyle}>
                <SvgComponent
                    icon={<EditIcon />}
                    sx={svgStyle}
                />
                EDITAR PERFIL
            </ButtonComponent>

            <ButtonComponent id="botao-alteracao-senha" disabled sx={buttonsStyle}>
                <SvgComponent
                    icon={<ChaveIcon />}
                    sx={svgStyle}
                />
                ALTERAR SENHA
            </ButtonComponent>

            <ButtonComponent id="botao-sair" type="button" onClick={() => props.onClickLogout()} sx={buttonsStyle}>
                <SvgComponent
                    icon={<Logouticon />}
                    sx={svgStyle}
                />
                SAIR DA CONTA
            </ButtonComponent>
        </BoxComponent>
    </Popover>
}

export default PopoverHeaderComponent;